<template>
  <div id="lom-list">
    <v-container class="py-0">
      <v-speed-dial
        v-model="fab"
        :top="top"
        :bottom="bottom"
        :right="right"
        :left="left"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
        :fixed="true"
        v-if="SpeedDialFlag"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab"> mdi-close </v-icon>
            <v-icon v-else> mdi-account-circle </v-icon>
          </v-btn>
        </template>
        <!-- <v-btn fab dark small color="green">
            <v-icon>mdi-pencil</v-icon>
          </v-btn> -->
        <v-btn fab dark small color="indigo" @click.prevent="addRecord">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <!-- <v-btn fab dark small color="red">
            <v-icon>mdi-delete</v-icon>
          </v-btn> -->
      </v-speed-dial>
    </v-container>
    <v-dialog v-model="previewRecordPrompt" persistent max-width="70%">
      <student-scholarship-approval
        pageDescription="Student scholarship preview"
        :previewRecordPrompt="previewRecordPrompt"
        @hidePreviewRecordPrompt="hidePreviewRecordPrompt"
        :recordData="selectedData"
        v-if="previewRecordPrompt"
      ></student-scholarship-approval>
    </v-dialog>

    <v-dialog v-model="notEligibleRecordPrompt" persistent max-width="70%">
      <student-scholarship-not-eligible
        pageDescription="Student scholarship not eligible records"
        :notEligibleRecordPrompt="notEligibleRecordPrompt"
        @hideNotEligibleRecordPrompt="hideNotEligibleRecordPrompt"
        :recordData="selectedData"
        v-if="notEligibleRecordPrompt"
      ></student-scholarship-not-eligible>
    </v-dialog>
    <v-card class="premium-card">
      <!-- Premium Page Header -->
      <div class="premium-page-header">
        <div class="header-inner-content">
          <div class="header-left">
            <div class="header-title-container">
              <span class="header-accent-bar"></span>
              <h1 class="header-title">{{ PageTitle }} - {{ YearName }}</h1>
            </div>
            <p class="header-description">
              {{
                PageDescription ||
                "Search and generate scholarship reports based on selected filters."
              }}
            </p>
          </div>
          <div class="header-right">
            <div class="header-badge">
              <div class="badge-icon-container">
                <v-icon small color="#EDBE38">mdi-school</v-icon>
              </div>
              <span class="badge-text">Scholarship Management</span>
            </div>
            <div class="header-year-card">
              <div class="year-card-left">
                <span class="year-card-label">Academic Year</span>
                <span class="year-card-value">{{ YearName || "2026" }}</span>
              </div>
              <div class="year-card-right">
                <v-icon size="32" class="year-card-icon"
                  >mdi-calendar-month-outline</v-icon
                >
              </div>
            </div>
          </div>
          <!-- Decorative Background Arcs -->
          <div class="header-arc-1"></div>
          <div class="header-arc-2"></div>
        </div>
      </div>

      <v-card-text class="card-content-area">
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>

        <!-- Dummy form to prevent error from this.$refs.form3 in resetForm -->
        <v-form ref="form3" style="display: none"></v-form>

        <v-container class="px-0">
          <v-form
            ref="form2"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="searchForm"
            class="premium-filter-form"
          >
            <v-row wrap>
              <!-- 1. Year -->
              <v-col cols="12" sm="6" lg="4" md="6" class="filter-col">
                <div class="filter-card-wrapper">
                  <div class="filter-icon-box icon-year">
                    <v-icon color="white">mdi-calendar-blank-outline</v-icon>
                  </div>
                  <div class="filter-field-content">
                    <label class="filter-label">
                      <span class="required-asterisk">*</span>Year
                    </label>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :items="JciYearCodeOptions"
                      :rules="JciYearCodeRules"
                      :loading="JciYearCodeOptionsLoading"
                      v-model="JciYearCode"
                      placeholder="Select Year"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-input"
                    ></v-autocomplete>
                  </div>
                </div>
              </v-col>

              <!-- 2. Zone -->
              <v-col cols="12" sm="6" lg="4" md="6" class="filter-col">
                <div class="filter-card-wrapper">
                  <div class="filter-icon-box icon-zone">
                    <v-icon color="white">mdi-map-marker-outline</v-icon>
                  </div>
                  <div class="filter-field-content">
                    <label class="filter-label">Zone (Optional)</label>
                    <v-autocomplete
                      @change="getLomCodeOptions"
                      :reduce="(option) => option.value"
                      :loading="ZoneCodeOptionsLoading"
                      :items="ZoneCodeOptions"
                      v-model="ZoneCode"
                      placeholder="--Select Zone--"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-input"
                    ></v-autocomplete>
                  </div>
                </div>
              </v-col>

              <!-- 3. LO -->
              <v-col cols="12" sm="6" lg="4" md="6" class="filter-col">
                <div class="filter-card-wrapper">
                  <div class="filter-icon-box icon-lo">
                    <v-icon color="white">mdi-city</v-icon>
                  </div>
                  <div class="filter-field-content">
                    <label class="filter-label">LO (Optional)</label>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="LomCodeOptionsLoading"
                      :items="LomCodeOptions"
                      v-model="LomCode"
                      placeholder="--Select LO--"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-input"
                    ></v-autocomplete>
                  </div>
                </div>
              </v-col>

              <!-- 4. Scholarship Type -->
              <v-col cols="12" sm="6" lg="4" md="6" class="filter-col">
                <div class="filter-card-wrapper">
                  <div class="filter-icon-box icon-type">
                    <v-icon color="white">mdi-school</v-icon>
                  </div>
                  <div class="filter-field-content">
                    <label class="filter-label"
                      >Scholarship Type (Optional)</label
                    >
                    <v-autocomplete
                      v-model="ScholarshipType"
                      :items="ScholarshipTypeOptions"
                      item-text="text"
                      item-value="value"
                      placeholder="--Select Type--"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-input"
                    ></v-autocomplete>
                  </div>
                </div>
              </v-col>

              <!-- 5. Scholarship Status -->
              <v-col cols="12" sm="6" lg="4" md="6" class="filter-col">
                <div class="filter-card-wrapper">
                  <div class="filter-icon-box icon-status">
                    <v-icon color="white">mdi-clipboard-text-outline</v-icon>
                  </div>
                  <div class="filter-field-content">
                    <label class="filter-label"
                      >Scholarship Status (Optional)</label
                    >
                    <v-autocomplete
                      v-model="Status"
                      :items="StatusOptions"
                      item-text="text"
                      item-value="value"
                      placeholder="--Select Status--"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-input"
                    ></v-autocomplete>
                  </div>
                </div>
              </v-col>

              <!-- 6. Gender -->
              <v-col cols="12" sm="6" lg="4" md="6" class="filter-col">
                <div class="filter-card-wrapper">
                  <div class="filter-icon-box icon-gender">
                    <v-icon color="white">mdi-account-outline</v-icon>
                  </div>
                  <div class="filter-field-content">
                    <label class="filter-label">Gender (Optional)</label>
                    <v-autocomplete
                      v-model="Gender"
                      :items="GenderOptions"
                      item-text="text"
                      item-value="value"
                      placeholder="--Select Gender--"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-input"
                    ></v-autocomplete>
                  </div>
                </div>
              </v-col>

              <!-- 7. Mark Percent -->
              <v-col cols="12" sm="6" lg="4" md="6" class="filter-col">
                <div class="filter-card-wrapper">
                  <div class="filter-icon-box icon-percent">
                    <v-icon color="white">mdi-percent</v-icon>
                  </div>
                  <div class="filter-field-content">
                    <label class="filter-label">Mark Percent (Optional)</label>
                    <v-text-field
                      v-model="MarkPercent"
                      type="number"
                      placeholder="Enter Mark Percent"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-input"
                    ></v-text-field>
                  </div>
                </div>
              </v-col>

              <!-- 8. Category -->
              <v-col cols="12" sm="6" lg="4" md="6" class="filter-col">
                <div class="filter-card-wrapper">
                  <div class="filter-icon-box icon-category">
                    <v-icon color="white">mdi-tag-outline</v-icon>
                  </div>
                  <div class="filter-field-content">
                    <label class="filter-label">Category (Optional)</label>
                    <v-autocomplete
                      v-model="Category"
                      :items="CategoryOptions"
                      item-text="text"
                      item-value="value"
                      placeholder="--Select Category--"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-input"
                    ></v-autocomplete>
                  </div>
                </div>
              </v-col>

              <!-- 9. Annual Income -->
              <v-col cols="12" sm="6" lg="4" md="6" class="filter-col">
                <div class="filter-card-wrapper">
                  <div class="filter-icon-box icon-income">
                    <v-icon color="white">mdi-wallet-outline</v-icon>
                  </div>
                  <div class="filter-field-content">
                    <label class="filter-label">Annual Income (Optional)</label>
                    <v-text-field
                      v-model="AnnualIncome"
                      type="number"
                      placeholder="Enter Annual Income"
                      dense
                      clearable
                      required
                      outlined
                      class="premium-input"
                    ></v-text-field>
                  </div>
                </div>
              </v-col>
            </v-row>

            <!-- Action Buttons -->
            <div class="buttons-row mt-4">
              <v-btn
                class="search-button mr-3"
                @click="searchForm"
                :loading="LoadingFlag"
                elevation="0"
              >
                <v-icon left>mdi-magnify</v-icon>
                SEARCH
              </v-btn>
              <v-btn
                class="reset-button"
                @click="
                  JciYearCode = null;
                  ZoneCode = null;
                  LomCode = null;
                  ScholarshipType = null;
                  Status = null;
                  Gender = null;
                  MarkPercent = null;
                  Category = null;
                  AnnualIncome = null;
                  resetForm();
                  resetValidation();
                "
                elevation="0"
              >
                <v-icon left>mdi-refresh</v-icon>
                RESET
              </v-btn>
            </div>
          </v-form>
        </v-container>

        <!-- Results and Data Table Section -->
        <div class="results-section mt-5" v-if="rows.length > 0">
          <div class="results-header mb-4">
            <div class="results-count">
              <v-icon color="#56BDA3" class="mr-2"
                >mdi-check-circle-outline</v-icon
              >
              <span
                ><strong>{{ rows.length }}</strong> students found.</span
              >
            </div>
            <div class="results-actions">
              <v-btn
                v-if="DownloadFlag"
                class="download-btn mr-3"
                @click.prevent="
                  generateExcel(
                    rows,
                    ExcelFields,
                    ExcelFileName,
                    'My Worksheet'
                  )
                "
                elevation="0"
              >
                <v-icon left>mdi-download</v-icon> Download
              </v-btn>
              <v-btn
                v-if="NotEligibleFlag && AdminFlag"
                class="not-eligible-btn"
                @click.prevent="
                  selectedData = selected;
                  notEligibleRecordPrompt = true;
                "
                :disabled="selected.length == 0"
                elevation="0"
              >
                <v-icon left>mdi-alert-circle-outline</v-icon> Not Eligible
              </v-btn>
            </div>
          </div>

          <div class="table-search-wrapper mb-4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search records here"
              single-line
              hide-details
              outlined
              dense
              class="table-search-input"
            ></v-text-field>
          </div>

          <div class="premium-table-container">
            <v-data-table
              class="premium-table"
              v-model="selected"
              :headers="tableColumns1"
              :items="rows"
              :items-per-page="50"
              :search="search"
              item-key="StudentId"
              :single-select="false"
              :show-select="tableOptions1.ShowSelectFlag"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50],
              }"
            >
              <template v-slot:[`item.StudentApprovalStatusTxt`]="{ item }">
                <v-chip
                  draggable
                  dark
                  :color="item.StudentApprovalStatusColor"
                  :class="[
                    'premium-chip',
                    item.StudentApprovalStatusTxt === 'Rejected'
                      ? 'status-rejected'
                      : '',
                    item.StudentApprovalStatusTxt === 'Submitted'
                      ? 'status-submitted'
                      : '',
                    item.StudentApprovalStatusTxt === 'Applied' ||
                    item.StudentApprovalStatusTxt === 'Pending'
                      ? 'status-applied'
                      : '',
                  ]"
                  >{{ item.StudentApprovalStatusTxt }}</v-chip
                >
              </template>
              <template v-slot:[`item.ScholarshipStatusTxt`]="{ item }">
                <v-chip
                  draggable
                  dark
                  :color="item.ScholarshipStatusColor"
                  :class="[
                    'premium-chip',
                    item.ScholarshipStatusTxt === 'Rejected'
                      ? 'status-rejected'
                      : '',
                    item.ScholarshipStatusTxt === 'Submitted'
                      ? 'status-submitted'
                      : '',
                    item.ScholarshipStatusTxt === 'Applied' ||
                    item.ScholarshipStatusTxt === 'Pending'
                      ? 'status-applied'
                      : '',
                  ]"
                  >{{ item.ScholarshipStatusTxt }}</v-chip
                >
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom v-if="item.PreviewFlag">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      class="action-btn"
                      @click="previewData(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon size="20px">mdi-file-search</v-icon>
                    </v-btn>
                  </template>
                  <span> Preview </span>
                </v-tooltip>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import StudentScholarshipPreview from "@/view/pages/erp/student-scholarship/StudentScholarshipPreview.vue";
import StudentScholarshipApproval from "@/view/pages/erp/student-scholarship/StudentScholarshipApproval.vue";
import StudentScholarshipNotEligible from "@/view/pages/erp/student-scholarship/StudentScholarshipNotEligible.vue";

export default {
  components: {
    StudentScholarshipPreview,
    StudentScholarshipApproval,
    StudentScholarshipNotEligible,
  },

  mixins: [common],
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      SpeedDialFlag: false,
      rows: [],
      tableColumns1: [],
      tableOptions1: {},
      selected: [],
      search: "",

      ScholarshipType: null,
      ScholarshipTypeOptions: [
        { text: "--Select Status--", value: null },
        { text: "NA", value: 0 },
        { text: "Normal", value: 1 },
        { text: "Empower her", value: 2 },
      ],

      Status: null,
      StatusOptions: [
        { text: "--Select Status--", value: null },
        { text: "InActive", value: 0 },
        { text: "Submitted", value: 1 },
        { text: "Partially saved", value: 2 },
      ],

      Gender: null,
      GenderOptions: [
        { text: "--Select Gender--", value: null },
        { text: "Male", value: 1 },
        { text: "Female", value: 2 },
      ],

      Category: null,
      CategoryOptions: [
        { text: "--Select--", value: "" },
        { text: "General", value: 1 },
        { text: "Orphan", value: 2 },
        { text: "Specially abled", value: 3 },
        { text: "Single parent", value: 4 },
        { text: "Girl child", value: 5 },
      ],

      DownloadFlag: "",
      ExcelFileName: "student_scholarship_details.xls",

      NotEligibleFlag: false,

      recordToEdit: "",
      record: {},
      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,
      editPageDescription: "Assign LO President for JCI India",

      notEligibleRecordPrompt: false,

      LomDataPageTitle: "",
      LomDataPreviewFlag: false,
      LomDataParams: {},

      ZoneCode: null,
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCode: null,
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      selectedData: {},

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      RoleId: "",
      AdminFlag: false,
    };
  },
  mounted() {
    /*
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "Vuetify", route: "alerts" },
        { title: "Form Inputs & Control", route: "autocompletes" },
        { title: "Fileinptus" },
      ]);
      */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        this.RoleId = RoleId;
        console.log("RoleId=" + RoleId);
        this.AdminFlag =
          RoleId === 1 || RoleId === 2 || RoleId === 4 ? true : false;
        this.pageData();
      }
    },
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
    JciYearCodeOptions: function () {
      console.log("watch JciYearCodeOptions");
      this.LoadingFlag = false;
      this.JciYearCodeOptionsLoading = false;
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      // this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
      this.LoadingFlag = false;
      this.ZoneCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LomCodeOptionsLoading = false;
    },
  },
  methods: {
    getChipStyle(headerName, fieldKey, rawVal) {
      if (rawVal == null || rawVal == undefined || rawVal === "") return null;
      const val = String(rawVal).trim();
      const lowerVal = val.toLowerCase();
      const lowerHeader = String(headerName).toLowerCase();
      const lowerKey = String(fieldKey).toLowerCase();

      const isApprovalStatus = lowerHeader.includes("approval status") || lowerKey.includes("approvalstatus");
      const isReportStatus = lowerHeader.includes("report status") || lowerHeader.includes("scholarship status") || lowerKey.includes("scholarshipstatus");
      const isGender = lowerHeader.includes("gender") || lowerKey === "gender";
      const isCategory = lowerHeader.includes("category") || lowerKey === "category";
      const isScholarshipType = lowerHeader.includes("scholarship type") || lowerKey.includes("scholarshiptype");
      const isAccountStatus = lowerHeader.includes("account status") || lowerKey.includes("accountstatus");

      if (isApprovalStatus || isReportStatus) {
        if (lowerVal.includes("approve") || lowerVal.includes("complete")) {
          return { bg: "#E8F5E9", color: "#1B5E20", border: "#A5D6A7" };
        }
        if (lowerVal.includes("reject")) {
          return { bg: "#FFEBEE", color: "#C62828", border: "#EF9A9A" };
        }
        if (lowerVal.includes("submit")) {
          return { bg: "#E3F2FD", color: "#1565C0", border: "#90CAF9" };
        }
        if (lowerVal.includes("pending") || lowerVal.includes("review")) {
          return { bg: "#FFF8E1", color: "#E65100", border: "#FFE082" };
        }
        if (lowerVal.includes("apply") || lowerVal.includes("applied")) {
          return { bg: "#E0F7FA", color: "#006064", border: "#80DEEA" };
        }
        if (lowerVal.includes("inactive")) {
          return { bg: "#EEEEEE", color: "#616161", border: "#BDBDBD" };
        }
        return { bg: "#F5F5F5", color: "#424242", border: "#E0E0E0" };
      }

      if (isGender) {
        if (lowerVal === "male" || lowerVal === "m") {
          return { bg: "#E3F2FD", color: "#1565C0", border: "#90CAF9" };
        }
        if (lowerVal === "female" || lowerVal === "f") {
          return { bg: "#F3E5F5", color: "#6A1B9A", border: "#CE93D8" };
        }
        return { bg: "#F5F5F5", color: "#424242", border: "#E0E0E0" };
      }

      if (isCategory) {
        if (lowerVal.includes("general")) {
          return { bg: "#E3F2FD", color: "#1565C0", border: "#90CAF9" };
        }
        if (lowerVal.includes("orphan")) {
          return { bg: "#F3E5F5", color: "#6A1B9A", border: "#CE93D8" };
        }
        if (lowerVal.includes("disabled") || lowerVal.includes("specially")) {
          return { bg: "#FFF3E0", color: "#E65100", border: "#FFCC80" };
        }
        if (lowerVal.includes("single")) {
          return { bg: "#E0F2F1", color: "#004D40", border: "#80CBC4" };
        }
        if (lowerVal.includes("girl")) {
          return { bg: "#FCE4EC", color: "#880E4F", border: "#F48FB1" };
        }
        return { bg: "#F5F5F5", color: "#424242", border: "#E0E0E0" };
      }

      if (isScholarshipType) {
        if (lowerVal === "na" || lowerVal === "") {
          return { bg: "#F5F5F5", color: "#616161", border: "#E0E0E0" };
        }
        if (lowerVal.includes("empower")) {
          return { bg: "#FFFDE7", color: "#F57F17", border: "#FFF59D" };
        }
        if (lowerVal.includes("normal") || lowerVal.includes("general") || lowerVal.includes("standard") || lowerVal.includes("one time")) {
          return { bg: "#E3F2FD", color: "#1565C0", border: "#90CAF9" };
        }
        return { bg: "#F5F5F5", color: "#424242", border: "#E0E0E0" };
      }

      if (isAccountStatus) {
        if (lowerVal.includes("active") || lowerVal.includes("verify") || lowerVal.includes("approve")) {
          return { bg: "#E8F5E9", color: "#1B5E20", border: "#A5D6A7" };
        }
        if (lowerVal.includes("pending")) {
          return { bg: "#FFF8E1", color: "#E65100", border: "#FFE082" };
        }
        if (lowerVal.includes("reject") || lowerVal.includes("failed") || lowerVal.includes("inactive")) {
          return { bg: "#FFEBEE", color: "#C62828", border: "#EF9A9A" };
        }
        return { bg: "#F5F5F5", color: "#424242", border: "#E0E0E0" };
      }

      return null;
    },
    generateExcel(TableData, TableHeader, FileName, SheetName) {
      if (!TableData || !TableHeader) return;

      let html = `<html xmlns:o="urn:schemas-microsoft-office:office" xmlns:x="urn:schemas-microsoft-office:excel" xmlns="http://www.w3.org/TR/REC-html40">
<head>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8">
<!--[if gte mso 9]>
<xml>
 <x:ExcelWorkbook>
  <x:ExcelWorksheets>
   <x:ExcelWorksheet>
    <x:Name>${SheetName || 'Scholarship Report'}</x:Name>
    <x:WorksheetOptions>
     <x:DisplayGridlines/>
     <x:FreezePanes/>
     <x:FrozenNoSplit/>
     <x:SplitHorizontal>1</x:SplitHorizontal>
     <x:TopRowBottomPane>1</x:TopRowBottomPane>
     <x:ActivePane>2</x:ActivePane>
    </x:WorksheetOptions>
   </x:ExcelWorksheet>
  </x:ExcelWorksheets>
 </x:ExcelWorkbook>
</xml>
<![endif]-->
<style>
  table { border-collapse: collapse; font-family: 'Segoe UI', Calibri, Arial, sans-serif; font-size: 10pt; }
  th { background-color: #3A67B1; color: #FFFFFF; font-weight: bold; font-size: 10.5pt; border: 1px solid #2B4E8C; padding: 10px 14px; text-align: center; vertical-align: middle; }
  td { border: 1px solid #E2E8F0; padding: 7px 10px; vertical-align: middle; }
</style>
</head>
<body>
<table border="1" cellspacing="0" cellpadding="6">
<thead>
  <tr>`;

      for (let headerName in TableHeader) {
        html += `<th bgcolor="#3A67B1" align="center" style="background-color: #3A67B1; color: #FFFFFF; font-weight: bold; font-size: 10.5pt; border: 1px solid #2B4E8C; padding: 10px 14px; text-align: center; vertical-align: middle;"><font color="#FFFFFF"><b>${headerName}</b></font></th>`;
      }

      html += `</tr>
</thead>
<tbody>`;

      TableData.forEach((row, rowIndex) => {
        const rowBg = rowIndex % 2 === 0 ? "#FFFFFF" : "#F8FAFC";
        html += `<tr bgcolor="${rowBg}" style="background-color: ${rowBg};">`;

        for (let headerName in TableHeader) {
          const fieldKey = TableHeader[headerName];
          let cellValue = row[fieldKey] == null || row[fieldKey] == undefined ? "" : row[fieldKey];

          const chipStyle = this.getChipStyle(headerName, fieldKey, cellValue);

          if (chipStyle) {
            html += `<td bgcolor="${chipStyle.bg}" align="center" style="background-color: ${chipStyle.bg}; color: ${chipStyle.color}; font-weight: bold; text-align: center; border: 1px solid ${chipStyle.border}; padding: 7px 10px; vertical-align: middle;"><font color="${chipStyle.color}"><b>${cellValue}</b></font></td>`;
          } else {
            html += `<td bgcolor="${rowBg}" align="left" style="background-color: ${rowBg}; border: 1px solid #E2E8F0; padding: 7px 10px; vertical-align: middle;">${cellValue}</td>`;
          }
        }
        html += `</tr>`;
      });

      html += `</tbody></table></body></html>`;

      const blob = new Blob([html], { type: "application/vnd.ms-excel;charset=utf-8" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      let exportName = FileName || "student_scholarship_details.xls";
      if (!exportName.endsWith(".xls") && !exportName.endsWith(".xlsx")) {
        exportName += ".xls";
      }
      link.download = exportName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "student_scholarship",
        Action: "report_1",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getJciYearCodeOptions();
      this.getLomCodeOptions();
      this.getZoneCodeOptions();
    },
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    addRecord() {
      console.log("addRecord called");
      var url = "/lom/create";
      var params = {};
      this.pageRedirect(params, url);
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      this.searchForm();
    },
    hidePreviewRecordPrompt(flag) {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    hideNotEligibleRecordPrompt(flag) {
      console.log("hideNotEligibleRecordPrompt called");
      this.notEligibleRecordPrompt = false;
      if (flag) {
        this.selected = [];
        this.searchForm();
      }
    },
    previewData(tr) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options";
      var selectbox1_conditions_array = {
        UserInterface: 4,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var ZoneCode = this.ZoneCode;
      console.log({ ZoneCode });
      if (ZoneCode != "") {
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        message += "Zone should not be empty. ";
      }
    },
    getJciYearCodeOptions() {
      this.LoadingFlag = true;
      this.JciYearCodeOptionsLoading = true;
      console.log("getJciYearCodeOptions called");
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    searchForm() {
      console.log("searchForm is called");

      this.LoadingFlag = true;

      var validate1 = this.$refs.form2.validate();
      var SearchId = this.SearchId;
      var UserInterface = SearchId == 1 ? 1 : 3;
      console.log(
        "validate1=" +
          validate1 +
          ", SearchId=" +
          SearchId +
          ", UserInterface=" +
          UserInterface
      );

      if (validate1) {
        this.SearchFlag = true;
        this.rows = [];
        this.zone = {};
        this.lom = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/lists";
        var upload = {
          UserInterface: 2,
          YearCode: this.JciYearCode,
          ZoneCode: this.ZoneCode,
          LomCode: this.LomCode,
          Type: this.ScholarshipType,
          Status: this.Status,
          Gender: this.Gender,
          MarkPercent: this.MarkPercent,
          Category: this.Category,
          AnnualIncome: this.AnnualIncome,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var table = {};
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            table = response.data.TableContent;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.tableColumns1 = table.TableHeader;
            thisIns.rows = table.TableData;

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.tableOptions1 = response.data.TableOptions;
              let tableOptions1 = thisIns.tableOptions1;
              thisIns.ExcelFields = tableOptions1.ExcelFields;
              thisIns.ExcelFileName = tableOptions1.ExcelFileName;
              thisIns.DownloadFlag = tableOptions1.ExcelDownloadFlag;
              thisIns.NotEligibleFlag = true;
            } else {
              thisIns.toast("error", output);
            }
            thisIns.LoadingFlag = false;
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap");

#lom-list {
  font-family: "Plus Jakarta Sans", sans-serif !important;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 12px;

  .v-btn--floating {
    position: relative;
  }
  .v-speed-dial--bottom {
    bottom: 12%;
  }
  .v-speed-dial--right {
    right: 5%;
  }

  // Premium Main Card (Modified to serve as transparent layout container)
  .premium-card {
    background-color: transparent !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    border: none !important;
    overflow: visible !important;
    margin-bottom: 32px;
    position: relative;
  }

  // Premium Page Header (Matching the custom screenshot layout & styles)
  .premium-page-header {
    position: relative;
    border-radius: 20px;
    background: linear-gradient(
      135deg,
      #edbe38 0%,
      #0097d7 60%,
      #56bda3 100%
    ) !important; /* The border gradient */
    padding: 1.5px !important; /* Border width */
    overflow: hidden;
    box-shadow: 0 12px 35px rgba(58, 103, 177, 0.15) !important;
    margin-bottom: 24px;

    .header-inner-content {
      border-radius: 19px; /* slightly smaller to fit inside border */
      background: radial-gradient(
          circle at 60% 30%,
          rgba(255, 255, 255, 0.35) 0%,
          transparent 6%
        ),
        radial-gradient(
          circle at 65% 70%,
          rgba(237, 190, 56, 0.35) 0%,
          transparent 8%
        ),
        radial-gradient(
          circle at 85% 25%,
          rgba(255, 255, 255, 0.25) 0%,
          transparent 12%
        ),
        radial-gradient(
          circle at 80% 20%,
          rgba(255, 255, 255, 0.15) 0%,
          transparent 50%
        ),
        radial-gradient(
          circle at 10% 90%,
          rgba(86, 189, 163, 0.2) 0%,
          transparent 50%
        ),
        linear-gradient(
          135deg,
          #0f4c81 0%,
          #3a67b1 30%,
          #0097d7 65%,
          #56bda3 100%
        );
      padding: 32px 36px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100%;

      // Dot patterns on inner content
      &::before {
        content: "";
        position: absolute;
        width: 160px;
        height: 120px;
        top: 15px;
        right: 20px;
        background-image: radial-gradient(
          rgba(255, 255, 255, 0.18) 1.5px,
          transparent 1.5px
        );
        background-size: 14px 14px;
        opacity: 0.55;
        z-index: 1;
        pointer-events: none;
        mask-image: radial-gradient(
          circle at center,
          black 30%,
          transparent 90%
        );
        -webkit-mask-image: radial-gradient(
          circle at center,
          black 30%,
          transparent 90%
        );
      }

      &::after {
        content: "";
        position: absolute;
        width: 140px;
        height: 100px;
        bottom: 10px;
        left: 10px;
        background-image: radial-gradient(
          rgba(255, 255, 255, 0.18) 1.5px,
          transparent 1.5px
        );
        background-size: 14px 14px;
        opacity: 0.45;
        z-index: 1;
        pointer-events: none;
        mask-image: radial-gradient(
          circle at center,
          black 30%,
          transparent 90%
        );
        -webkit-mask-image: radial-gradient(
          circle at center,
          black 30%,
          transparent 90%
        );
      }
    }

    .header-left {
      display: flex;
      flex-direction: column;
      z-index: 2;
    }

    .header-title-container {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 8px;
    }

    .header-accent-bar {
      width: 4px;
      height: 28px;
      background-color: #ffffff;
      border-radius: 2px;
      display: inline-block;
      box-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
    }

    .header-title {
      font-size: 28px;
      font-weight: 700;
      color: #ffffff !important;
      margin: 0;
      line-height: 1.2;
    }

    .premium-breadcrumb {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 11px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.7) !important;
      margin-bottom: 12px;
      text-transform: uppercase;
      letter-spacing: 1px;

      .breadcrumb-item {
        &.active {
          color: #56bda3 !important;
          font-weight: 700;
        }
      }
      .breadcrumb-separator {
        color: rgba(255, 255, 255, 0.4) !important;
      }
    }

    .header-description {
      font-size: 13.5px;
      color: rgba(255, 255, 255, 0.85) !important;
      margin: 0;
      max-width: 800px;
      line-height: 1.5;
    }

    .header-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      z-index: 2;
    }

    .header-badge {
      background: #052659; /* JCI Dark Navy */
      border: 1.5px solid #edbe38; /* Gold border */
      border-radius: 30px;
      padding: 4px 16px 4px 6px;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      box-shadow: 0 4px 15px rgba(5, 38, 89, 0.3);
      margin-bottom: 16px;

      .badge-icon-container {
        width: 24px;
        height: 24px;
        background: #0c3670;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .badge-text {
        color: #ffffff;
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.8px;
      }
    }

    .header-year-card {
      width: 260px;
      background: rgba(255, 255, 255, 0.07);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-top: 2.5px solid #edbe38;
      border-radius: 16px;
      padding: 16px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0 10px 30px rgba(10, 15, 41, 0.05);

      .year-card-left {
        display: flex;
        flex-direction: column;
      }

      .year-card-label {
        font-size: 11.5px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.75);
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 2px;
      }

      .year-card-value {
        font-size: 32px;
        font-weight: 800;
        color: #ffffff;
        line-height: 1.1;
      }

      .year-card-right {
        display: flex;
        align-items: center;
        justify-content: center;

        .year-card-icon {
          color: rgba(255, 255, 255, 0.45) !important;
        }
      }
    }

    // Gentle wave animations/curves at bottom using border-radius
    .header-arc-1 {
      position: absolute;
      bottom: -130px;
      left: -20%;
      width: 140%;
      height: 240px;
      background: linear-gradient(
        90deg,
        rgba(0, 151, 213, 0.08) 0%,
        rgba(86, 189, 163, 0.12) 100%
      );
      border-radius: 50%;
      z-index: 1;
      pointer-events: none;
    }

    .header-arc-2 {
      position: absolute;
      bottom: -170px;
      left: -10%;
      width: 120%;
      height: 260px;
      background: linear-gradient(
        90deg,
        rgba(86, 189, 163, 0.08) 0%,
        rgba(0, 151, 213, 0.12) 100%
      );
      border-radius: 50%;
      z-index: 1;
      pointer-events: none;
    }
  }

  // Card Content Area (Side paddings removed to align cards vertically)
  .card-content-area {
    padding: 32px 0 0 0 !important;
  }

  // Filter Section Grid Layout
  .filter-col {
    padding: 12px 10px !important;
  }

  .premium-filter-form {
    background: #ffffff;
    border-radius: 24px;
    box-shadow: 0 18px 45px rgba(58, 103, 177, 0.1);
    padding: 32px;
    position: relative;
    margin-bottom: 32px;

    // Thin top border using gradient
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #3a67b1, #0097d7, #56bda3);
      border-top-left-radius: 24px;
      border-top-right-radius: 24px;
    }
  }

  .filter-card-wrapper {
    display: flex;
    align-items: flex-start;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
  }

  .filter-icon-box {
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    margin-top: 28px; /* align with 56px height inputs */
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(10, 15, 41, 0.05);

    .v-icon {
      color: #ffffff !important;
      font-size: 20px !important;
    }

    &.icon-year {
      background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%);
    }
    &.icon-zone,
    &.icon-lo {
      background: linear-gradient(135deg, #0097d7 0%, #56bda3 100%);
    }
    &.icon-category,
    &.icon-percent,
    &.icon-income {
      background: linear-gradient(135deg, #edbe38 0%, #f7d76a 100%);
    }
    &.icon-type,
    &.icon-status,
    &.icon-gender {
      background: linear-gradient(135deg, #56bda3 0%, #0097d7 100%);
    }

    &:hover {
      transform: scale(1.08) translateY(-1px);
      box-shadow: 0 6px 15px rgba(10, 15, 41, 0.08);
    }
  }

  .filter-field-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    min-width: 0; /* allows overflow ellipsis to work correctly */
  }

  .filter-label {
    font-size: 13px;
    font-weight: 600;
    color: #414042;
    margin-bottom: 8px !important;
    display: block;
    height: 18px;
    line-height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: 0.2px;

    .required-asterisk {
      color: #ef4444;
      margin-right: 4px;
      font-weight: 700;
    }
  }

  // Premium Inputs overriding Vuetify default styles
  .premium-input {
    font-size: 14px !important;

    .v-input__slot {
      min-height: 56px !important;
      height: 56px !important;
      border-radius: 14px !important;
      background-color: #ffffff !important;
      border: 1px solid #dce7f5 !important;
      box-shadow: inset 0 2px 4px rgba(10, 15, 41, 0.02) !important;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;

      fieldset {
        border: none !important; /* Hide default fieldset */
      }

      .v-select__slot {
        height: 100% !important;
        display: flex;
        align-items: center !important;
      }

      .v-input__append-inner {
        margin-top: 0 !important;
        align-self: center !important;
      }

      &:hover {
        border-color: rgba(
          0,
          151,
          213,
          0.4
        ) !important; /* AQUA light hover border */
      }
    }

    &.v-input--is-focused {
      .v-input__slot {
        border-color: #0097d7 !important; /* AQUA focus border */
        box-shadow: inset 0 2px 4px rgba(10, 15, 41, 0.01),
          0 0 0 4px rgba(0, 151, 215, 0.12) !important; /* AQUA soft glow */
      }
    }

    // Adjusting text field inner paddings
    .v-text-field__slot {
      padding: 0 6px !important;
      height: 100% !important;
      display: flex;
      align-items: center !important;

      input {
        max-height: 38px !important;
        color: #414042 !important;
      }
    }
  }

  // Action Buttons
  .buttons-row {
    display: flex;
    justify-content: flex-start;
    padding-left: 62px; /* aligns buttons with inputs, skipping the icon spacing */
    margin-bottom: 8px;
    gap: 12px;
  }

  .search-button {
    height: 48px !important;
    border-radius: 14px !important;
    background-image: linear-gradient(
      135deg,
      #3a67b1 0%,
      #0097d7 100%
    ) !important;
    color: #ffffff !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    letter-spacing: 0.5px !important;
    padding: 0 28px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 10px 30px rgba(58, 103, 177, 0.25) !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 35px rgba(58, 103, 177, 0.35) !important;
    }

    &:active {
      transform: translateY(0) scale(0.98);
    }
  }

  .reset-button {
    height: 48px !important;
    border-radius: 14px !important;
    background-image: linear-gradient(
      135deg,
      #0097d7 0%,
      #56bda3 100%
    ) !important;
    color: #ffffff !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    letter-spacing: 0.5px !important;
    padding: 0 28px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 10px 30px rgba(0, 151, 213, 0.15) !important;

    .v-icon {
      color: #ffffff !important;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 35px rgba(0, 151, 213, 0.25) !important;
    }

    &:active {
      transform: translateY(0) scale(0.98);
    }
  }

  // Results Section
  .results-section {
    border-top: 1px solid rgba(58, 103, 177, 0.06);
    padding-top: 32px;
    margin-top: 32px;
    position: relative;
  }

  .results-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .results-count {
    display: flex;
    align-items: center;
    background: #ffffff;
    border-left: 6px solid #56bda3;
    padding: 16px 24px;
    border-radius: 4px 14px 14px 4px;
    box-shadow: 0 4px 20px rgba(86, 189, 163, 0.05);
    position: relative;
    overflow: hidden;
    margin-right: 16px;
    flex-grow: 1;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        90deg,
        rgba(86, 189, 163, 0.08) 0%,
        rgba(86, 189, 163, 0.02) 100%
      );
      pointer-events: none;
    }

    // Success icon inside circular badge
    .v-icon {
      background: rgba(86, 189, 163, 0.15) !important;
      border-radius: 50% !important;
      width: 32px !important;
      height: 32px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      color: #56bda3 !important;
      font-size: 18px !important;
      margin-right: 14px !important;
      z-index: 1;
    }

    span {
      font-size: 15px;
      color: #414042;
      z-index: 1;

      strong {
        color: #0a0f29;
        font-size: 18px;
        font-weight: 700;
        margin-right: 4px;
      }
    }
  }

  .download-btn {
    height: 44px !important;
    border-radius: 12px !important;
    background-image: linear-gradient(
      135deg,
      #56bda3 0%,
      #46a98e 100%
    ) !important;
    color: #ffffff !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    letter-spacing: 0.2px !important;
    padding: 0 20px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 6px 20px rgba(86, 189, 163, 0.15) !important;

    .v-icon {
      color: #ffffff !important;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(86, 189, 163, 0.25) !important;
    }

    &:active {
      transform: translateY(0) scale(0.98);
    }
  }

  .not-eligible-btn {
    height: 44px !important;
    border-radius: 12px !important;
    background-image: linear-gradient(
      135deg,
      #edbe38 0%,
      #f5c85d 100%
    ) !important;
    color: #0a0f29 !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    letter-spacing: 0.2px !important;
    padding: 0 20px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 4px 12px rgba(237, 190, 56, 0.15) !important;

    .v-icon {
      color: #0a0f29 !important;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(237, 190, 56, 0.25) !important;
    }

    &:active {
      transform: translateY(0) scale(0.98);
    }

    &:disabled {
      background-image: none !important;
      background-color: #f1f5f9 !important;
      color: #94a3b8 !important;
      box-shadow: none !important;
      transform: none !important;
      .v-icon {
        color: #94a3b8 !important;
      }
    }
  }

  .table-search-wrapper {
    max-width: 320px;
    margin-left: auto;
  }

  .table-search-input {
    font-size: 13px !important;

    .v-input__slot {
      border-radius: 24px !important;
      border: 1.5px solid #dce7f5 !important;
      min-height: 48px !important;
      height: 48px !important;
      background-color: #ffffff !important;
      box-shadow: 0 4px 15px rgba(10, 15, 41, 0.03) !important;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
      padding-right: 6px !important;

      fieldset {
        border: none !important;
      }

      &:hover {
        border-color: rgba(0, 151, 213, 0.5) !important;
      }
    }

    &.v-input--is-focused {
      .v-input__slot {
        border-color: #0097d7 !important;
        box-shadow: 0 0 0 4px rgba(0, 151, 215, 0.12) !important;
      }
    }

    .v-input__append-inner {
      width: 38px !important;
      height: 38px !important;
      background: linear-gradient(135deg, #3a67b1 0%, #0097d7 100%) !important;
      border-radius: 50% !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0 !important;
      align-self: center !important;

      .v-icon {
        color: #ffffff !important;
        font-size: 18px !important;
      }
    }
  }

  // Premium Data Table
  .premium-table-container {
    border-radius: 20px;
    border: 1px solid rgba(10, 15, 41, 0.05);
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(10, 15, 41, 0.02);
    transition: all 0.3s ease;
    background: #ffffff;

    &:hover {
      box-shadow: 0 15px 40px rgba(10, 15, 41, 0.04);
    }
  }

  .premium-table {
    th {
      position: sticky !important;
      top: 0 !important;
      z-index: 3 !important;
      background: linear-gradient(135deg, #3a67b1 0%, #2d5daa 100%) !important;
      color: #ffffff !important;
      font-size: 13px !important;
      font-weight: 700 !important;
      height: 60px !important;
      border-bottom: 3px solid #edbe38 !important;
      text-transform: uppercase;
      letter-spacing: 1px;

      // Make sort and check icon white if present
      .v-data-table-header__icon {
        color: #ffffff !important;
      }

      .v-simple-checkbox {
        .v-icon {
          color: #ffffff !important;
        }
      }
    }

    td {
      font-size: 14px !important;
      color: #414042 !important;
      height: 60px !important;
      padding: 12px 16px !important;
      border-bottom: 1px solid #f1f5f9 !important;
    }

    tr:nth-child(even) {
      background-color: #fafcff !important;
    }

    tr:nth-child(odd) {
      background-color: #ffffff !important;
    }

    tr:hover {
      background-color: rgba(0, 151, 215, 0.05) !important;
      transition: background-color 0.25s ease;
    }
  }

  // Chips styled as soft premium badges
  .premium-chip {
    font-size: 11px !important;
    font-weight: 700 !important;
    border-radius: 8px !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    height: 26px !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    box-shadow: 0 2px 6px rgba(10, 15, 41, 0.05) !important;

    &.status-rejected {
      background-image: linear-gradient(
        135deg,
        #e53935 0%,
        #d32f2f 100%
      ) !important;
      color: #ffffff !important;
    }
    &.status-submitted {
      background-image: linear-gradient(
        135deg,
        #56bda3 0%,
        #2faf7f 100%
      ) !important;
      color: #ffffff !important;
    }
    &.status-applied {
      background-image: linear-gradient(
        135deg,
        #edbe38 0%,
        #f7c94b 100%
      ) !important;
      color: #0a0f29 !important;
    }
  }

  .action-btn {
    width: 36px !important;
    height: 36px !important;
    background-color: #f4f8ff !important;
    border-radius: 8px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: none !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;

    .v-icon {
      color: #3a67b1 !important;
      transition: color 0.25s ease !important;
    }

    &:hover {
      background-image: linear-gradient(
        135deg,
        #3a67b1 0%,
        #0097d7 100%
      ) !important;
      transform: scale(1.08) translateY(-1px);
      box-shadow: 0 4px 12px rgba(58, 103, 177, 0.2) !important;

      .v-icon {
        color: #ffffff !important;
      }
    }
  }

  // Circular outlined pagination inside data footer
  .v-data-footer {
    border-top: 1px solid #f1f5f9 !important;
    padding: 16px 24px !important;
    font-size: 13px !important;
    color: #414042 !important;

    .v-data-footer__select {
      .v-select {
        margin: 0 12px !important;
        .v-input__slot {
          min-height: 36px !important;
          height: 36px !important;
          border-radius: 8px !important;
          border: 1.5px solid #dce7f5 !important;
          background: #ffffff !important;
          box-shadow: none !important;

          &:hover {
            border-color: #0097d7 !important;
          }
        }
      }
    }

    .v-btn--icon {
      width: 36px !important;
      height: 36px !important;
      border-radius: 50% !important;
      border: 1.5px solid #3a67b1 !important;
      color: #3a67b1 !important;
      margin: 0 6px !important;
      background: #ffffff !important;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;

      &:hover {
        background-color: rgba(0, 151, 215, 0.05) !important;
        border-color: #0097d7 !important;
        color: #0097d7 !important;
        transform: translateY(-1px);
      }

      &.v-btn--disabled {
        border-color: #e2e8f0 !important;
        color: #94a3b8 !important;
        background: #f8fafc !important;
        transform: none !important;
      }
    }
  }
}

// Media Queries for Responsiveness
@media (max-width: 960px) {
  #lom-list {
    .premium-page-header {
      flex-direction: column;
      align-items: flex-start;
      padding: 24px;
    }

    .buttons-row {
      padding-left: 0;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 600px) {
  #lom-list {
    padding: 12px 6px;

    .card-content-area {
      padding: 16px;
    }

    .filter-card-wrapper {
      flex-direction: column;

      .filter-icon-box {
        margin-top: 0;
        margin-bottom: 10px;
      }
    }

    .premium-page-header {
      padding: 16px;

      .header-title {
        font-size: 22px;
      }
    }
  }
}
</style>
